<script lang="ts">
  import type { User } from "$types";
  import { get_pattern } from "$lib/utilities";
  import {
    ArrowFatLeft,
    InstagramLogo,
    Link,
    YoutubeLogo,
  } from "phosphor-svelte";
  import { teams } from "$lib/data";
  import Avatar from "$components/profile/Avatar.svelte";
  import DisplayName from "$components/profile/DisplayName.svelte";
  import MajorMilestones from "$components/members/achievements/MajorMilestones.svelte";
  import MugClub from "$components/members/achievements/MugClub.svelte";
  import GlitterMilestones from "$components/members/achievements/GlitterMilestones.svelte";
  import YearsOfSupport from "$components/members/achievements/YearsOfSupport.svelte";

  export let member: User;

  let team_index = -1;
  if (member.team) team_index = teams.findIndex((t) => t.value === member.team);
</script>

<div class="header">
  <div class="divider">
    <div class="top">
      <div class="avatar">
        <Avatar user={member} />
      </div>
      <div class="text">
        <h1>
          <DisplayName user={member} />
        </h1>
        <div class="meta">
          {#if member.team}
            <div
              class="team"
              style:background={member.team ? teams[team_index].color : "white"}
              color={member.team ? "white" : "var(--offDark)"}
            >
              Team {teams[team_index].name}
            </div>
          {/if}
          <div class="handle">@<span>{member.handle}</span></div>
        </div>
      </div>
      <div class="achievements">
        <MajorMilestones count={member.major_milestones} />
        <MugClub achieved={member.mug_club} />
        <GlitterMilestones count={member.glitter_milestones} />
        <YearsOfSupport count={member.years_of_support} />
      </div>
    </div>
    <div class="menu" style:background={get_pattern()}>
      {#if member.profile?.homepage}
        <a
          href={member.profile.homepage}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Link />
          Visit Homepage
        </a>
      {/if}
      {#if member.profile?.instagram}
        <a
          href={member.profile.instagram}
          target="_blank"
          rel="noopener noreferrer"
        >
          <InstagramLogo />
          Instagram
        </a>
      {/if}
      {#if member.profile?.youtube}
        <a
          href={member.profile.youtube}
          target="_blank"
          rel="noopener noreferrer"
        >
          <YoutubeLogo />
          YouTube Channel
        </a>
      {/if}
      <a class="back_to" href="/community">
        <ArrowFatLeft />
        Back to Community
      </a>
    </div>
  </div>
</div>

<style>
  .back_to {
    margin-left: auto;
    border-right: none;
    border-left: 1px solid var(--dots);
  }
  .header {
    display: flex;
    gap: 1rem;
    background: white;
    border-radius: 1rem;
    box-shadow: var(--shadow);
    width: 100%;
  }

  .divider {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .achievements {
    padding: 1rem;
    display: grid;
    gap: 1rem;
    grid-template-columns: 1fr 1fr;
    flex-shrink: 0;
    margin-left: auto;
  }
  .top {
    display: flex;
    gap: 1rem;
    padding: 1rem;
    align-items: center;
  }

  .text {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    flex-shrink: 0;
  }

  .meta {
    display: flex;
    gap: 1rem;
    font-size: 0.9rem;
    color: var(--offDark);
    align-items: center;
  }

  .handle {
    font-size: 1.1rem;
    color: var(--primary);
    font-weight: bold;
  }

  .handle span {
    color: var(--title);
  }

  h1 {
    display: flex;
    text-align: center;
    margin: 0;
    padding: 0;
    font-size: 2.2rem;
    font-family: "Open Sans", sans-serif;
    color: transparent;
    font-weight: bold;
    -webkit-text-stroke-width: 1.8px;
    -webkit-text-stroke-color: var(--title);
    text-shadow: 1.5px 1.5px var(--primary);
  }

  .team {
    padding: 0.5rem 1rem;
    border-radius: 0.5rem;
    color: white;
    font-weight: bold;
  }

  .menu {
    border-top: 1px solid var(--dots);
    display: flex;
  }

  .menu a {
    display: flex;
    gap: 1rem;
    align-items: center;
    padding: 1rem;
    text-decoration: none;
    border-right: 1px solid var(--dots);
    font-size: 0.9rem;
  }

  .avatar {
    aspect-ratio: 1;
    width: 7rem;
    height: 7rem;
  }

  @media (max-width: 1024px) {
    .header .top {
      flex-wrap: wrap;
    }
  }
  @media (max-width: 768px) {
    .header {
      border-radius: 0;
    }

    .header .text {
      justify-content: center;
      align-items: center;
    }
    .menu {
      font-size: 0.8rem;
      display: grid;
      grid-template-columns: 1fr 1fr;
    }

    .menu a {
      justify-content: center;
    }

    .menu .back_to {
      grid-column: span 2;
      border: none;
      display: flex;
      justify-content: center;
      width: 100%;
      border-top: 1px solid var(--dots);
    }
    .header .top {
      flex-direction: column;
      gap: 1rem;
      align-items: center;
      justify-content: center;
    }
    .header .top .achievements {
      margin: 0;
    }
  }
</style>
